import React from "react";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Switch from "@mui/material/Switch";
import { Checkbox, Select } from "@mui/material";
import Slide from "@mui/material/Slide";
import InputBase from "@mui/material/InputBase";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import BLimg from "../../assets/images/betterLife.png";
import { styled } from "@mui/material/styles";
import { red } from "@mui/material/colors";
import { Custom } from "@mui/material";
export const CustomTextField = styled(TextField)({
  "& label": {
    font: "18px bloggerSans",
  },
  "& label.Mui-focused": {
    color: "#58CC02",
  },

  "& .MuiInput-underline:after": {
    borderBottomColor: "green",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#D3D3D3",
    },
    "&:hover fieldset": {
      borderColor: "#000",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#58CC02",
    },
  },
  Select: {
    "& .MuiButtonBase-root.MuiMenuItem-root": {
      "&.Mui-selected": {
        backgroundColor: "red",
      },
    },
  },

  "& .MuiOutlinedInput-root MuiInputBase-root": {
    "&.Mui-focused ": {
      borderColor: "#58CC02",
    },
  },
});
export const CustomCheckbox = styled(Checkbox)({
  "&.Mui-checked": {
    color: "#58CC02",
  },

  // "&.MuiChip-clickable:hover": {
  //   backgroundColor: "#58CC02",
  //   color: "white",
  //   borderColor: "#58CC02",
  // },
  // "&:hover": {
  //   backgroundColor: "#58CC02",
  //   color: "white",
  //   borderColor: "#58CC02",
  // },
  // "&:focus": {
  //   backgroundColor: "#58CC02",
  //   color: "white",
  // },
});
export const CustomSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#65C466",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

export const CustomButton = styled(Button)({
  textTransform: "none",
  font: "1rem feather",
  borderRadius: "10px",
  padding: 25,
  color: "white",
  "&:hover": {
    backgroundColor: "#F8DF3F",
  },
});

export const CustomButton1 = styled(Button)({
  textAlign: "center",
  py: "15px",
  px: "50px",
  textTransform: "none",
  fontFamily: "bloggerSans",
  fontSize: "20px",
  border: "1px solid #58CC02",
  borderRadius: "10px",
  color: "#58CC02",
  "&:hover": {
    backgroundColor: "#58CC02",
    color: "white",
    borderColor: "#58CC02",
  },
  "&:active": {
    backgroundColor: "#58CC02",
    color: "white",
  },
});

export const CustomChip = styled(Chip)({
  textAlign: "center",
  padding: "20px 10px",
  textTransform: "none",
  fontFamily: "bloggerSans",
  borderColor: "#58CC02",
  borderRadius: "10px",
  color: "#58CC02",
  backgroundColor: "white",
  fontSize: "20px",
  "&.MuiChip-clickable:hover": {
    backgroundColor: "#58CC02",
    color: "white",
    borderColor: "#58CC02",
  },
  "&:hover": {
    backgroundColor: "#58CC02",
    color: "white",
    borderColor: "#58CC02",
  },
  "&:focus": {
    backgroundColor: "#58CC02",
    color: "white",
  },
});

export const CustomText = styled(Typography)({
  fontFamily: "bloggerSans",
  fontWeight: 500,
  fontSize: "18px",
  "& a": { fontFamily: "bloggerSans" },
  "& span": { color: "black" },
  "& h3": { color: "grey" },
});
export const CustomGrey = styled(Typography)({
  display: "inline",
  // fontFamily: "bloggerSans",
  // fontWeight: 500,
  // fontSize: "18px",
  // "& a": { fontFamily: "bloggerSans" },
  // "& span": { color: "black" },
  color: "grey",
});
export const CustomTitle = styled(Typography)({
  fontFamily: "feather",
});

// export const CustomTableCell = styled(TableCell)(({ theme }) => ({
//   [`&.${tableCellClasses.head}`]: {
//     backgroundColor: ,
//     color: theme.palette.common.white,
//   },
//   [`&.${tableCellClasses.body}`]: {
//     fontSize: 14,
//   },
// }));
